import styled, { css } from 'styled-components'

export const OptionSelectorWrapper = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
  `}
`

export const OptionLabel = styled.span`
  ${() => css`
    font-size: 16px;
    font-weight: 700;
    color: rgb(69, 78, 79);
  `}
`

export const OptionSelectorOption = styled.span`
  ${({ selected = false }) => css`
    color: #1E5BC6;
    padding: 16px 60px;
    cursor: pointer;
    border-radius: 4px;

    ${selected && css`
      background-color: rgb(0, 24, 69);
      color: #FFF;
      font-weight: 700;
    `}
    
  `}
`

export const OptionsContainer = styled.div`
  ${() => css`
    display: flex;
    border: 1px solid rgb(165, 179, 183);
    width: fit-content;
    border-radius: 4px;
    margin-top: 8px;
  `}
`